<template>
    <div class="download">
        <div class="download_container">
            <div class="download_top">
                <p style="text-align: center; font-family: AliRegular; font-size: 3rem; color: #fff; padding: 8rem 0 0 0;">{{ title }}</p>
                <p style="text-align: center; font-family: AliRegular; font-size: 1rem; padding: 1rem 15% 7%; line-height: 30px; color: rgb(141 141 141);">{{ content }}</p>
                <div class="download_button">
                    <div class="system win" :style="{
                            background: isHover1 ? 'rgba(120, 120, 120, 0.5)' : '#222222',
                            backdropFilter: isHover1 ? 'blur(3px)' : 'none',
                            WebkitBackdropFilter: isHover1 ? 'blur(3px)' : 'none'
                        }" 
                        @mouseover="isHover1 = true" @mouseleave="isHover1 = false">
                        <div class="title">通用免费版</div>
                        <div class="line"></div>
                        <div class="content">适合中小企业、高校和个人从业者，可以满足通用的基本功能</div>
                        <div class="price"><span>0</span>元/年</div>
                        <div class="btn">
                            <el-button class="free" @click="isDownLoadDialog = true">免费试用</el-button>
                        </div>
                    </div>
                    <div class="system mac" :style="{
                            background: isHover2 ? 'rgba(120, 120, 120, 0.5)' : '#222222',
                            backdropFilter: isHover2 ? 'blur(3px)' : 'none',
                            WebkitBackdropFilter: isHover2 ? 'blur(3px)' : 'none'
                        }" 
                        @mouseover="isHover2 = true" @mouseleave="isHover2 = false">
                        <div class="title">个性化定制</div>
                        <div class="line"></div>
                        <div class="content">适合私有化部署和行业深度应用的专业设计机构、行业中大型企业</div>
                        <div class="price"><span>面议</span></div>
                        <div class="btn">
                            <el-button class="free" @click="goAbout">现在试用</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-container">
            <el-dialog
                title=""
                :visible.sync="isDownLoadDialog"
                width="80%"
                @close="handleClose"
            >
                <div class="container">
                    <div class="system win">
                        <div class="logo">
                            <div class="logo_container">
                                <img src="../../assets/image/windons.png">
                            </div>
                        </div>
                        <div class="download_coin" title="下载Windows版本"  @click="downloadSoft('win')" >
                            <p style="text-align: center; font-size: 1.1rem; font-weight: 600; letter-spacing: 1px;
                                      margin: 1rem 0 0.6rem 0;">Windows</p>
                            <p style="text-align: center; color: #333333; font-size: 0.8rem; margin-bottom: 2%;">版本型号：PONGO{{ winInfo.version }}</p>
                            <p style="text-align: center; color: #666666; font-size: 0.8rem; padding-bottom: 2%;">软件大小：{{ winInfo.displaySize }}</p>
                            <p style="text-align: center; color: #666666; font-size: 0.8rem; padding-bottom: 2%;">更新日期：{{ winInfo.releaseAt }}</p>
                        </div>
                    </div>
                    <div class="system mac">
                        <div class="logo">
                            <div class="logo_container">
                                <img src="../../assets/image/mac.png">
                            </div>
                        </div>
                        <div class="download_coin"  title="下载Mac版本" @click="downloadSoft('mac')" >
                            <!-- <img @mouseenter="showColorIcon(2)"
                                 @mouseleave="closeColorIcon(2)"
                                 :src="isDownLoad2 ? require('../../assets/image/下载按钮2.png') : require('../../assets/image/下载按钮.png')"
                                 @click="downloadSoft('mac')" style="margin-left: 80%; margin-top: 0.5rem; cursor: pointer;"> -->
                            <p style="text-align: center; font-size: 1.1rem; font-weight: 600; letter-spacing: 1px;
                                      margin: 1rem 0 0.6rem 0;">Mac OS</p>
                            <p style="text-align: center; color: #333333; font-size: 0.8rem; margin-bottom: 0.5rem;">版本型号：PONGO{{ macInfo.version }}</p>
                            <p style="text-align: center; color: #666666; font-size: 0.8rem; padding-bottom: 0.5rem;">软件大小：{{ winInfo.displaySize }}</p>
                            <p style="text-align: center; color: #666666; font-size: 0.8rem; padding-bottom: 3rem;">更新日期：{{ macInfo.releaseAt }}</p>

                        </div>
                    </div>
                </div>        
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getNewVersion, getText } from '../../util/index'
export default {
    data() {
        return {
            isDownLoadDialog: false,
            isHover1: false,
            isHover2: false,
            title: '数字孪生平台',
            content: '利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案',
            isDownLoad: false,
            isDownLoad2: false,
            winInfo:{
                // download: "https://pgov.oss-cn-qingdao.aliyuncs.com/240131/1094074fca7243a689a5a573ca37d71a.exe",
                // time: '',
                // version: ''
                description: []
            },
            macInfo:{
                // download: "",
                // time: '',
                // version: ''
                description: []
            }
        }
    },
    mounted() {
        let page = '数字孪生平台'
        getText(page).then(res => {
            if(res.code === 200){
               this.title = res.data[0].title
               this.content = res.data[0].content
            }
            // console.log(this.winInfo);
        })
        getNewVersion({}).then(res => {
            if(res.code === 200){
                // this.winInfo.time = 
                this.macInfo = res.data.MacOS
                this.winInfo = res.data.Windows
                this.winInfo.description = this.winInfo.description.split('\n')
                this.macInfo.description = this.macInfo.description.split('\n')
            }
            // console.log(this.macInfo);
        })
    },
    components: {
    },
    methods: {
        handleClose(){
            
        },
        goAbout(){
            this.$router.push({
                path: '/about',
                hash: '#contact'
            })
        },
        downloadSoft(str){
            // console.log(this.macInfo.macLink);
            if(str === 'mac'){
                window.location.href = this.macInfo.download;
            }else{
                window.location.href = this.winInfo.download;
            }
            // window.open(this.winInfo.download)
        },
        showColorIcon(num){
            if(num === 1){
                this.isDownLoad = true;
            }else{
                this.isDownLoad2 = true;
            }
        },
        closeColorIcon(num){
            if(num === 1){
                this.isDownLoad = false;
            }else{
                this.isDownLoad2 = false;
            }
        }
    }
}
</script>

<style scoped lang="less">
// .download{
    // background-color: #000;
// }
.download_container {
    width: 100%;
    // margin-bottom: 5rem;
    .download_top{
        width: 100%;
        // height: 600px;
        background-image: url("../../assets/image/底.png");
        background-size: cover;
        .download_button{
            display: flex;
            width: 70%;
            // background-color: #d0d0d0;
            margin: 0 auto;
            padding-bottom: 15rem;
            justify-content: space-between;
            height: 30%;
            @media screen and (max-width: 1600px) {
                width: 70%;
            }
            .system{
                border-radius: 10px;
                background-color: #222222;
                width: 41%;
                padding: 60px 40px 70px;
                min-width: 400px;
                // box-shadow: 0.4rem 0.4rem 0.4rem #7881aba8;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                backdrop-filter: blur(2px);
                .title{
                    font-size: 28px;
                    color: #fff;
                    font-weight: bold;
                    letter-spacing: 2px;
                }
                .line{
                    width: 20px;
                    height: 1px;
                    background-color: #f73501;
                    margin: 5px 0;
                }
                .content{
                    font-size: 13px;
                    color: #999999;
                }
                .price{
                    span{
                        color: #f73501;
                        font-size: 32px;
                        letter-spacing: 2px;
                        font-weight: bold;
                    }
                    margin: 50px 0 20px;
                    font-size: 16px;
                    color: #fff;
                    
                }
                .btn{
                    // background-color: #f73501;
                    .free{
                        border-radius: 25px;
                        width: 160px;
                        background-color: #f73501;
                        border: none;
                        color: #fff;
                        font-size: 20px;
                        letter-spacing: 1px;
                    }
                }
            }
        }
    }
    .download_bottom{
        // width: 80%;
        background-color: #333333;
        color: #bcbcbc;
        padding: 2rem 0;
        .download_bottom_container{
            margin: 0 auto;
            width: 90%;
            // background-color: rgb(178, 127, 255);
            display: flex;
            justify-content: center;
            .update_content{
                padding: 0 5%;
                border-right: 2px solid #999999;
                .update_p1{
                    font-size: 1.5rem;
                    margin-top: 4rem;
                    margin-bottom: 1rem;
                    color: #fff;
                    text-align: center;
                }
                .update_p2{
                    font-size: 1rem;
                    margin-bottom: 4rem;
                    color: #999999;
                }
            }
            .version{
                display: flex;
                padding: 0 5%;
                flex-direction: column;
                .update_p3{
                    font-size: 1.2rem;
                    margin-top: 2rem;
                    margin-bottom: 1rem;
                }
            }
        }
    }
}
.dialog-container{
    ::v-deep .el-dialog{
        padding: 10% 0;
        border-radius: 10px;
        background-image: url("../../assets/image/2.1.png");
    }
    .container{
        display: flex;
        justify-content: space-around;
        .system{
                border-radius: 1rem;
                background-color: #ffffff5e;
                width: 20%;
                min-width: 400px;
                box-shadow: 0.4rem 0.4rem 0.4rem #7881aba8;
                display: flex;
                backdrop-filter: blur(2px);
                cursor: pointer;
                .logo{
                    width: 50%;
                    display: flex;
                    .logo_container{
                        display: flex;
                        justify-content: center;
                        width: 90%;
                        margin: auto;
                        border-right: #818181 solid 0.1rem;
                    }
                }
                .download_coin{
                    width: 49%;
                    padding-top: 1rem;
                }
            }
    }
}

</style>